






























































import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import { Ref } from '@vue/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import { useDep } from '~/compositions/dependency-container'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import { useI18n } from '~/compositions/i18n'
import { ciExternalLink } from '~/icons/source/regular/external-link'
import { defineComponentTranslations } from '~/utils/i18n'
import CYesOrNoButtonGroup from '~/components/shared/configurable/form/checkbox/CYesOrNoButtonGroup.vue'

export default defineComponent({
  props: formFieldProps,
  components: {
    CYesOrNoButtonGroup,
    FieldError,
    CAvatar
  },
  setup(props) {
    const { specs, name } = props
    const acceptsAudits = ref<boolean>(false)
    const error = ref(null)
    const selectedDistance = ref<number>(20)

    function onValue(v: Ref<any>) {
      acceptsAudits.value = v.value?.accepts_audits || false
      selectedDistance.value = v.value?.max_distance_for_outcall_audits || 0
    }

    function onError(e: Ref<any>) {
      if (e.value) {
        error.value =
          e.value.max_distance_for_outcall_audits ||
          e.value.accepts_audits ||
          e.value
      }
    }
    const { valueChanged, formIsDispatched } = useClassifiedForm(props, {
      onValue,
      onError
    })
    const formValidationBuilder = useDep(FormValidationBuilder)

    const { t } = useI18n()

    const maxDistanceOptions = computed(() => [
      {
        text: t('choose maximum distance'),
        value: -1,
        disabled: true,
        hidden: true
      },
      ...specs.max_distance_for_outcall_audits.values.map(v => ({
        value: v,
        text: v + ` ${t('km')}`
      })),
      {
        text: t('onsite_inspection'),
        value: 0
      }
    ])

    const handleAcceptsAuditsChange = (accepts: boolean) => {
      acceptsAudits.value = accepts
      error.value = null
      if (!accepts) {
        selectedDistance.value = -1
        valueChanged(name, null)
      } else {
        handleEmitValues()
      }
    }

    const handleDistanceChange = (distance: number) => {
      selectedDistance.value = distance
      error.value = null
      validateDistance()
      handleEmitValues()
    }

    const handleEmitValues = () => {
      if (!acceptsAudits.value && !selectedDistance.value) {
        valueChanged(name, null)
        return
      }
      valueChanged(name, {
        accepts_audits: acceptsAudits.value,
        max_distance_for_outcall_audits: selectedDistance.value
      })
    }

    const validateAcceptsAudits: boolean = () => {
      const acceptsAuditsSpecs = specs.accepts_audits
      formValidationBuilder
        .new(error)
        .required(acceptsAuditsSpecs.required, acceptsAudits.value)
        .validate()
      return !error.value
    }

    const validateDistance: boolean = () => {
      // const distanceSpecs = specs.max_distance_for_outcall_audits
      formValidationBuilder
        .new(error)
        .required(true, selectedDistance.value)
        .validate()
      return !error.value
    }

    return {
      acceptsAudits,
      error,
      selectedDistance,
      maxDistanceOptions,
      handleDistanceChange,
      validateDistance,
      validateAcceptsAudits,
      handleAcceptsAuditsChange,
      ciExternalLink,
      formIsDispatched
    }
  },
  i18n: defineComponentTranslations({
    audits_disclaimer: {
      en:
        'With the above acceptance I confirm that I am the legal owner of the vehicle or authorized representative and if the vehicle is audited, the details of the audit will be sent to the person concerned.',
      el:
        'Με την παραπάνω αποδοχή επιβεβαιώνω ότι είμαι ο νόμιμος κάτοχος του οχήματος ή εξουσιοδοτημένος εκπρόσωπος και εφόσον το όχημα ελεγχθεί, τα στοιχεία του ελέγχου θα αποσταλούν στον ενδιαφερόμενο.'
    },
    do_you_accept_audits: {
      en: 'Do you accept audits?',
      el: 'Δέχεσαι τεχνικούς ελέγχους;'
    }
  })
})
